import { render, staticRenderFns } from "./PrimeButton.vue?vue&type=template&id=3da4ca46&scoped=true"
import script from "./PrimeButton.vue?vue&type=script&lang=js"
export * from "./PrimeButton.vue?vue&type=script&lang=js"
import style0 from "./PrimeButton.vue?vue&type=style&index=0&id=3da4ca46&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3da4ca46",
  null
  
)

export default component.exports